import React from 'react';
import './privacy.scss';

const Privacy = () => {
   // const privacy = () => {
   //    const contents_1 = [
   //       'hytexts.com คือร้านหนังสืออิเล็กทรอนิกส์ (E-book) ที่ได้รับสิทธิ์อย่างถูกต้องในการโฆษณา จัดจำหน่ายหนังสืออิเล็กทรอนิกส์ (E-book) จากสำนักพิมพ์ที่เข้าร่วม'
   //    ];
   //    const contents_gather = [
   //       `1. หนังสืออิเล็กทรอนิกส์ (E-book) ที่จัดจำหน่ายในhytexts.com จะเป็นรูปแบบไฟล์PDF หรือePub ซึ่งจะถูกเข้ารหัสเพื่อควบคุมลิขสิทธิ์ (Digital Right Management) ทุกไฟล์ สมาชิกสามารถนำหนังสืออิเล็กทรอนิกส์ (E-book) ของ hytexts.com ไปอ่านในอุปกรณ์ที่รองรับต่างๆเช่น iPhone ,iPad ,Android,eReader,Pc และ Mac`,
   //       `2. เมื่อผู้ใช้บริการได้เข้าหรือออกจากhytexts.com รวมถึงการเข้าชมหน้าต่างๆของเว็บไซต์ hytexts.comจะมีการจัดเก็บค่าIP Address รวมถึงชนิดเว็บเบราเซอร์ของสมาชิกทั้งนี้ก็เพื่อนำข้อมูลเหล่านั้นมาวิเคราะห์และนำไปพัฒนาบริการของhytexts.com เพื่อตอบสนองความต้องการของสมาชิกในอนาคต`,
   //       `3. นโยบายความเป็นส่วนตัวฉบับนี้ ("นโยบายความเป็นส่วนตัว") ใช้บังคับคลอบคลุมถึงร้านค้าปลีก เว็บไซต์ แอพพลิเคชั่นบนโทรศัพท์มือถือ ศูนย์บริการข้อมูลลูกค้า (Call center) ช่องทางสื่อสังคมออนไลน์ ช่องทางการสื่อสารทางออนไลน์ ตลอดจนสถานที่อื่นๆ ที่ได้มีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน อย่างไรก็ตาม กรุณาอ่านนโยบายความเป็นส่วนตัวฉบับนี้ควบคู่กับข้อตกลงและเงื่อนไขสำหรับบริการเฉพาะดังกล่าวที่ท่านใช้`
   //    ];
   //    const contents_2 = [
   //       'ตามนโยบายความเป็นส่วนตัวฉบับนี้ "ข้อมูลส่วนบุคคล" หมายถึง "ข้อมูลใด ๆ ที่เกี่ยวข้องกับตัวบุคคลหรือที่ทำให้สามารถระบุตัวบุคคลนั้นได้ ตามที่ระบุด้านล่าง',
   //       'บริษัทขอสงวนสิทธิ์ในการแก้ไขนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว ดังนั้น โปรดตรวจสอบว่านโยบายความเป็นส่วนตัวนี้ได้รับการแก้ไขครั้งล่าสุดเมื่อใดเป็นประจำ การเปลี่ยนแปลงใดๆ จะมีผลทันทีเมื่อเราเผยแพร่นโยบายความเป็นส่วนตัวที่แก้ไขดังกล่าวลงในเว็บไซต์หรือแอปพลิเคชันของเรา เราจะแจ้งให้ท่านทราบหากมีการแก้ไขหรือปรับปรุงที่มีนัยสำคัญ',
   //       'ส่วนกรณีเป็นการแก้ไขเปลี่ยนแปลงที่เป็นการลิดรอนสิทธิของท่านในส่วนของข้อมูลที่ละเอียดอ่อนตามนโยบายความเป็นส่วนตัวฉบับนี้ บริษัทจะดำเนินการเพื่อขอความยินยอมจากท่านก่อน เว้นแต่เป็นกรณีที่กฎหมายกำหนดเป็นอย่างอื่น'
   //    ];

   //    const contents_thirdPerson = [
   //       '1. hytexts.com อาจใช้ข้อมูลที่ได้รับจากสมาชิกเพื่อใช้ในการการส่งเสริมการตลาดหรือให้ข้อมูลแก่หน่วยงานที่ทำหน้าที่ด้านการตลาดโดย hytexts.com เป็นผู้ว่าจ้างพันธมิตรทางธุรกิจหรือผู้ให้การสนับสนุนทางธุรกิจ ตามที่ hytexts.com เห็นสมควร',
   //       '2. การเปิดเผยข้อมูลนั้น ๆ เป็นไปโดยถูกต้องตามกฎหมายหรือตามคำสั่งของหน่วยงานของรัฐที่เกี่ยวข้อง'
   //    ];
   //    const contents_cookie =
   //       'คุกกี้ คือไฟล์ข้อความขนาดเล็กซึ่งถูกคัดลอกลงในฮาร์ดดิสก์ของคุณโดยเว็บไซต์ คุกกี้ไม่ทำให้คอมพิวเตอร์ของคุณเสียหาย และไม่มีไวรัสใดๆ ทั้งสิ้นคุกกี้จากเว็บไซต์ของเราจะไม่เก็บรวบรวมข้อมูลส่วนตัวของคุณคุณสามารถปิดการใช้งานคุกกี้ได้ตลอดเวลาผ่านการตั้งค่าในบราวเซอร์ของคุณตามกฎแล้วคุกกี้จะถูกใช้บนเว็บไซต์ของเราตามระยะเวลาที่คุณใช้งานเท่านั้น ทั้งนี้เพื่อใช้สำหรับวัตถุประสงค์ที่ไม่เป็นที่เปิดเผย การประเมินผลทางสถิติ และเพื่อการปรับปรุงความง่าย และสะดวกต่อการใช้งานสำหรับผู้ใช้ต่อไป ในบางกรณี คุกกี้อาจถูกใช้งานเพื่อวัตถุประสงค์อื่นๆ ในบางส่วนของเว็บไซต์คุณจะได้รับการแจ้งเตือนในกรณีนี้หากคุณเข้าใช้งานในส่วนที่เกี่ยวข้องดังกล่าว';
   //    const contents_cookie_list = [
   //       '1. คุกกี้คืออะไร',
   //       'คุกกี้ คือไฟล์ข้อความขนาดเล็กซึ่งถูกดาวน์โหลดไปยังคอมพิวเตอร์ของลูกค้า ไฟล์นี้อนุญาตให้เรา บริษัท ไฮเท็คซ์ อินเตอร์แอคทีฟ จำกัด สามารถรวบรวมข้อมูลเกี่ยวกับประวัติการเข้าชมเว็บไซต์ของผู้เยี่ยมชมได้',
   //       '2. ประโยชน์ของคุกกี้',
   //       'ด้วยการรวบรวมคุกกี้ เว็บไซต์จะสามารถมอบประสบการณ์การใช้งานที่ดีขึ้น และตรงกับความต้องการของลูกค้าในอนาคตได้ข้อมูลนี้จะถูกใช้โดย บริษัท ไฮเท็คซ์ อินเตอร์แอคทีฟ จำกัด เท่านั้น ดังนั้นการโอนถ่ายข้อมูลคุกกี้จึงไม่สามารถเกิดขึ้นได้',
   //       'คุกกี้จะบันทึกการตั้งค่าแรกของเว็บไซต์ไว้ด้วยเช่นกัน ซึ่งจะช่วยให้ลูกค้าได้รับค่าที่ตั้งไว้เดิมแต่แรกทุกครั้งที่ใช้งาน หากคุกกี้ถูกลบการตั้งค่าทุกอย่างจะกลับไปที่ค่าเริ่มต้น',
   //       '3. คุกกี้ไม่ทำให้เกิดอันตรายต่อคอมพิวเตอร์ของคุณ',
   //       'วัตถุประสงค์หลักของคุกกี้คือการรวบรวมข้อมูลในรูปแบบไฟล์ ซึ่งไม่มีหน้าที่อื่นใดนอกเหนือจากนี้',
   //       '4. สิ่งที่คุกกี้ไม่ได้รวบรวมมีอะไรบ้าง',
   //       'คุกกี้ไม่เก็บรวบรวมข้อมูลเกี่ยวกับข้อมูลรายละเอียดส่วนบุคคลของคุณเช่น หมายเลขโทรศัพท์ หรือวันเดือนปีเกิดของคุณหากมีการเก็บข้อมูลเพิ่มเติมนอกเหนือจากนี้จะต้องได้รับความยินยอมจากลูกค้าก่อนการเก็บข้อมูล',
   //       '5. วิธีการปิดการทำงานของคุกกี้ทำอย่างไร',
   //       'ลูกค้าสามารถปิดการตั้งค่าการทำงานของคุกกี้ได้โดยเข้าไปที่หน้าการตั้งค่าบราวเซอร์ และตั้งค่าความเป็นส่วนตัวเพื่อหยุดการรวบรวมข้อมูลทุกอย่างของคุกกี้ในอนาคต'
   //    ];
   //    const contents_responsibility =
   //       'hytexts.com ขอสงวนสิทธิ์ในการปฏิเสธความรับผิดทั้งหมดในกรณีที่ข้อมูลส่วนบุคคลของสมาชิกเสียหายหรือสูญหายเนื่องจากความผิดพลาดใดๆ ระหว่างส่งข้อมูลระหว่าง herevgo กับผู้ใช้บริการเหตุสุดวิสัยใดๆการถูกจารกรรมข้อมูลคอมพิวเตอร์(Hack) และ/หรือการกระทำใดๆที่ขัดกฎหมายไม่ว่าการกระทำนั้นจะเกิดจากบุคคลใด ๆ ก็ตาม';
   //    const contents_copyrights =
   //       'ลิขสิทธิ์ตามกฎหมาย(Copyrights) ข้อมูลหนังสืออิเล็กทรอนิส์(E-book) ข้อมูลตัวอย่างหนังสืออิเล็กทรอนิส์(E-book),ข้อความ ภาพ เสียงเนื้อหา ส่วนประกอบใด ๆ ทั้งหมดของ hytexts.com แต่ไม่จำกัดเฉพาะเครื่องหมายการค้าเครื่องหมายบริการ ชื่อทางการค้าที่ปรากฏบน hytexts.com เป็นงานอันได้รับความคุ้มครองตามกฎหมายทรัพย์สินทางปัญญาของไทยโดยชอบด้วยกฎหมายของ hytexts.com แต่เพียงผู้เดียว  หากบุคคลใดลอกเลียน ปลอมแปลงทำซ้ำ ดัดแปลง เผยแพร่ต่อสาธารณชนจำหน่าย มีไว้ให้เช่าหรือกระทำการใดๆในลักษณะที่เป็นการแสวงหาผลประโยชน์ทางการค้าหรือประโยชน์โดยมิชอบไม่ว่าโดยประการใดๆ จากทรัพย์สินทางปัญญาดังกล่าวข้างต้นโดยไม่ได้รับอนุญาตจากhytexts.com hytexts.comจะดำเนินการตามกฎหมายกับผู้ละเมิดสิทธิดังกล่าวโดยทันที';
   //    const contents_privacyChange = [
   //       'hytexts.com สามารถเปลียนแปลงนโยบายความเป็นส่วนตัวได้ตลอดเวลา เมื่อมีการเปลี่ยนแปลงหรือเพิ่มเติมบริการหรือเมื่อเราได้รับข้อเสนอแนะจากสมาชิก การเปลี่ยนแปลงใดๆในนโยบายจะมีการแจ้งถึงสมาชิกผ่านทางไปรษณีย์อิเล็กทรอนิกส์',
   //       'หากสมาชิกมีคำถามที่เกี่ยวข้องกับนโยบายความเป็นส่วนตัวของเราสมาชิกสามารถติดต่อผ่านที่อยู่ไปรษณีย์อิเล็กทรอนิกส์ contact@hytexts.com หรือผ่านหน้า“ติดต่อเรา”'
   //    ];

   //    const privacy_right = [
   //       'การเข้าถึง: ผู้ใช้งานอาจมีสิทธิ์ในการขอเข้าถึงหรือขอรับสำเนาข้อมูลส่วนบุคคลที่เราเก็บรวบรวม ใช้หรือเปิดเผยเกี่ยวกับผู้ใช้งาน ทั้งนี้ เพื่อความเป็นส่วนตัวและความปลอดภัยของผู้ใช้งาน เราอาจขอให้ผู้ใช้งานพิสูจน์ตัวตนของผู้ใช้งานก่อนจะให้ข้อมูลตามที่ผู้ใช้งานขอ',
   //       'การแก้ไขให้ถูกต้อง: ผู้ใช้งานอาจมีสิทธิ์ขอให้มีการดำเนินการแก้ไขข้อมูลส่วนบุคคลที่เราได้เก็บรวบรวม ใช้หรือเปิดเผยเกี่ยวกับผู้ใช้งาน ให้ ถูกต้อง เป็นปัจจุบัน สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด',
   //       'การคัดค้าน: ผู้ใช้งานอาจมีสิทธิ์คัดค้านการเก็บรวบรวม ใช้หรือเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้งาน เช่น การคัดค้านการตลาดแบบตรง',
   //       'การขอให้ระงับการใช้: ผู้ใช้งานอาจมีสิทธิ์ขอให้ระงับการใช้ข้อมูลส่วนบุคคลของผู้ใช้งานในบางกรณี',
   //       'การถอนความยินยอม: สำหรับวัตถุประสงค์ที่ผู้ใช้งานได้ให้ความยินยอมให้เราเก็บรวบรวม ใช้หรือเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้งาน ผู้ใช้งานมีสิทธิ์ที่จะถอนความยินยอมของผู้ใช้งาน ณ เวลาใด ก็ได้',
   //       'การลบหรือทำลายข้อมูล: ผู้ใช้งานอาจมีสิทธิ์ขอให้เราดำเนินการลบหรือทำลาย หรือทำให้ข้อมูลส่วนบุคคลของผู้ใช้งานที่เราเก็บรวบรวม ใช้หรือเปิดเผย เป็นข้อมูลที่ไม่สามารถระบุตัวบุคคลที่เป็นเจ้าของข้อมูล เว้นเสียแต่ว่า การเก็บรักษาข้อมูลดังกล่าวของเรานั้นเป็นไปเพื่อการปฏิบัติตามกฎหมาย หรือเพื่อก่อตั้งสิทธิ์เรียกร้องตามกฎหมาย เพื่อการใช้ หรือการปกป้องสิทธิ์เรียกร้องตามกฎหมาย',
   //       'การยื่นเรื่องร้องเรียน: ผู้ใช้งานอาจมีสิทธิ์ยื่นเรื่องร้องเรียนไปยังหน่วยงานที่มีอำนาจในกรณีที่ผู้ใช้งานเชื่อว่าการเก็บรวบรวม ใช้หรือเปิดเผยข้อมูลส่วนบุคคลของเรานั้นไม่ชอบด้วยกฎหมายหรือไม่สอดคล้องกับกฎหมายคุ้มครองข้อมูลที่บังคับใช้'
   //    ];

   //    return (
   //       <div className='side'>
   //          <p className='side-title-c'>นโยบายความเป็นส่วนตัว</p>
   //          {contents_1.map((e) => (
   //             <p className='side-content-lessBottom' key={e}>
   //                {e}
   //                <br />
   //             </p>
   //          ))}
   //          <p className='side-title'>การรวบรวมข้อมูล</p>
   //          {contents_gather.map((e) => (
   //             <p className='side-content-lessBottom' key={e}>
   //                {e}
   //                <br />
   //             </p>
   //          ))}
   //          <p className='side-title'>การเปิดเผยข้อมูลแก่บุคคลที่สาม</p>
   //          {contents_thirdPerson.map((e) => (
   //             <p className='side-content-lessBottom' key={e}>
   //                {e}
   //                <br />
   //             </p>
   //          ))}
   //          <p className='side-title'>คุกกี้ (COOKIE)</p>
   //          <p className='side-content-lessBottom'>
   //             {contents_cookie}
   //             <br />
   //          </p>
   //          {contents_cookie_list.map((e, index) => (
   //             <p className='side-content-lessBottom' key={index}>
   //                {e}
   //                <br />
   //             </p>
   //          ))}
   //          <p className='side-title'>ความรับผิดชอบ</p>
   //          <p className='side-content-lessBottom'>
   //             {contents_responsibility}
   //             <br />
   //          </p>
   //          <p className='side-title'>ลิขสิทธิ์ (COPYRIGHTS)</p>
   //          <p className='side-content-lessBottom'>
   //             {contents_copyrights}
   //             <br />
   //          </p>
   //          <p className='side-title'>การเปลี่ยนแปลงนโยบายความเป็นส่วนตัว</p>
   //          {contents_privacyChange.map((e) => (
   //             <p className='side-content-lessBottom' key={e}>
   //                {e}
   //                <br />
   //             </p>
   //          ))}

   //          <p className='side-title'>สิทธิ์ของเจ้าของข้อมูลส่วนบุคคล</p>
   //          <p className='side-content-lessBottom'>
   //             ภายใต้บทบัญญัติแห่งกฎหมายและข้อยกเว้นตามกฎหมายที่เกี่ยวข้อง ผู้ใช้งานอาจมีสิทธิ์ตามที่ระบุไว้
   //          </p>
   //          <p className='list-in-content'>
   //             <ul>
   //                {privacy_right.map((e, index) => (
   //                   <li key={index}>{e}</li>
   //                ))}
   //             </ul>
   //          </p>

   //          <p className='side-title'>ระยะเวลาในการที่เราเก็บข้อมูลส่วนบุคคล</p>
   //          <p className='side-content-lessBottom'>
   //             เราจะเก็บรักษาข้อมูลส่วนบุคคลของท่านในระยะเวลาเท่าที่จำเป็นอย่างสมเหตุสมผล
   //             เพื่อให้บรรลุตามวัตถุประสงค์ที่เราได้รับข้อมูลส่วนบุคคลนั้นมา <br />
   //             และเพื่อปฏิบัติตามภาระหน้าที่ทางกฎหมายและกฎข้อบังคับต่างๆ อย่างไรก็ตาม
   //             เราอาจเก็บข้อมูลส่วนบุคคลของท่านนานขึ้นหากจำเป็นตามกฎหมาย
   //             <br />
   //             ที่ใช้บังคับ
   //          </p>
   //       </div>
   //    );
   // };
   return (
      <div className='side privacy-policy-content'>
         <div className='side-title-c'>นโยบายความเป็นส่วนตัว</div>
         <div>
            <p>
               hytexts.com คือร้านหนังสืออิเล็กทรอนิกส์ (E-book) ที่ได้รับสิทธิ์อย่างถูกต้องในการโฆษณา
               จัดจำหน่ายหนังสืออิเล็กทรอนิกส์ (E-book) จากสำนักพิมพ์ที่เข้าร่วม
            </p>
            <ol style={{ marginBottom: 0 }}>
               <li>
                  หนังสืออิเล็กทรอนิกส์ (E-book) ที่จัดจำหน่ายในhytexts.com จะเป็นรูปแบบไฟล์PDF หรือePub
                  ซึ่งจะถูกเข้ารหัสเพื่อควบคุมลิขสิทธิ์ (Digital Right Management) ทุกไฟล์
                  สมาชิกสามารถนำหนังสืออิเล็กทรอนิกส์ (E-book) ของ hytexts.com ไปอ่านในอุปกรณ์ที่รองรับต่างๆเช่น iPhone
                  ,iPad ,Android,eReader,Pc และ Mac
               </li>
               <li>
                  เมื่อผู้ใช้บริการได้เข้าหรือออกจากhytexts.com รวมถึงการเข้าชมหน้าต่างๆของเว็บไซต์
                  hytexts.comจะมีการจัดเก็บค่าIP Address
                  รวมถึงชนิดเว็บเบราเซอร์ของสมาชิกทั้งนี้ก็เพื่อนำข้อมูลเหล่านั้นมาวิเคราะห์และนำไปพัฒนาบริการของhytexts.com
                  เพื่อตอบสนองความต้องการของสมาชิกในอนาคต
               </li>
               <li>
                  นโยบายความเป็นส่วนตัวฉบับนี้ {'("'}นโยบายความเป็นส่วนตัว{'")'} ใช้บังคับคลอบคลุมถึงร้านค้าปลีก
                  เว็บไซต์ แอพพลิเคชั่นบนโทรศัพท์มือถือ ศูนย์บริการข้อมูลลูกค้า (Call center) ช่องทางสื่อสังคมออนไลน์
                  ช่องทางการสื่อสารทางออนไลน์ ตลอดจนสถานที่อื่นๆ ที่ได้มีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน
                  อย่างไรก็ตาม
                  กรุณาอ่านนโยบายความเป็นส่วนตัวฉบับนี้ควบคู่กับข้อตกลงและเงื่อนไขสำหรับบริการเฉพาะดังกล่าวที่ท่านใช้
               </li>
            </ol>
            <p>
               ตามนโยบายความเป็นส่วนตัวฉบับนี้ {`"ข้อมูลส่วนบุคคล"`} หมายถึง{' '}
               {`"ข้อมูลใด ๆ
               ที่เกี่ยวข้องกับตัวบุคคลหรือที่ทำให้สามารถระบุตัวบุคคลนั้นได้ ตามที่ระบุด้านล่าง"`}
            </p>
            <p>
               บริษัทขอสงวนสิทธิ์ในการแก้ไขนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว ดังนั้น
               <br />
               โปรดตรวจสอบว่านโยบายความเป็นส่วนตัวนี้ได้รับการแก้ไขครั้งล่าสุดเมื่อใดเป็นประจำ การเปลี่ยนแปลงใดๆ
               <br />
               จะมีผลทันทีเมื่อเราเผยแพร่นโยบายความเป็นส่วนตัวที่แก้ไขดังกล่าวลงในเว็บไซต์หรือแอปพลิเคชันของเรา
               <br />
               เราจะแจ้งให้ท่านทราบหากมีการแก้ไขหรือปรับปรุงที่มีนัยสำคัญ
               <br />
               ส่วนกรณีเป็นการแก้ไขเปลี่ยนแปลงที่เป็นการลิดรอนสิทธิของท่านในส่วนของข้อมูลที่ละเอียดอ่อนตามนโยบายความเป็นส่วนตัวฉบับนี้
               <br />
               บริษัทจะดำเนินการเพื่อขอความยินยอมจากท่านก่อน เว้นแต่เป็นกรณีที่กฎหมายกำหนดเป็นอย่างอื่น
            </p>
         </div>

         <div>
            <h2>การรวบรวมข้อมูล</h2>
            <p>
               เราอาจมีการเก็บรวบรวมหรือรับข้อมูลประเภทดังต่อไปนี้ซึ่งอาจรวมไปถึงข้อมูลส่วนบุคคลของท่านโดยตรงหรือโดยอ้อมจากหรือแหล่งข้อมูลอื่นๆ
               หรือจากการยืนยันเครือ บริษัทย่อย หรือบริษัทอื่นๆ
               โดยลักษณะของข้อมูลส่วนบุคคลที่เราเก็บรวบรวมนั้นจะขึ้นอยู่กับบริบทของการติดต่อสื่อสารและความสัมพันธ์ของท่านกับเรา
               รวมถึงบริการหรือผลิตภัณฑ์ที่ท่านต้องการจากเรา
            </p>
            <ol>
               <li>
                  ในการสมัครสมาชิกกับ hytexts.com ผู้ใช้บริการจะต้องกรอกข้อมูลชื่อ ที่อยู่ เบอร์โทรศัพท์
                  อีเมลให้ถูกต้องและครบถ้วน (เช่น เลขที่บัตรประจำตัวประชาชน เลขประจำตัวผู้เสียภาษีอากร
                  หรือเอกสารระบุตัวตนที่มีลักษณะเดียวกัน เป็นต้น) และข้อมูลส่วนตัวอื่นๆ ที่ท่านได้มอบให้แก่เรา
                  ซึ่งการเก็บข้อมูลดังกล่าวใช้สำหรับพัฒนารูปการให้บริการ การบริการหลังการขาย
                  การประมวลผลข้อมูลเพื่อจัดทำข้อมูลทางการตลาดและสิทธิประโยชน์ของสมาชิก
               </li>
               <li>
                  ข้อมูลส่วนบุคคลที่สมาชิกได้ให้หรือใช้ผ่านการประมวลผลของเครื่องคอมพิวเตอร์ที่ควบคุมการทำงาน ของ
                  hytexts.com ทั้งหมดนั้นสมาชิกยอมรับและตกลงว่าเป็นสิทธิและกรรมสิทธิ์ของบริษัท hytexts.com
                  จะรักษาข้อมูลเหล่านั้นไว้เป็นความลับตามเกณฑ์มาตรฐานสากลสำหรับการรักษาข้อมูลเป็นความลับและจะไม่อนุญาตให้ผู้อื่นเข้าถึงข้อมูลดังกล่าวได้นอกจากพนักงานผู้ที่ได้รับอนุญาตจาก
                  hytexts.com อย่างไรก็ตามเพื่อความปลอดภัยในข้อมูลส่วนบุคคลของสมาชิก
                  สมาชิกควรปฏิบัติตามข้อกำหนดและเงื่อนไขการให้บริการของเว็บไซต์ของบริษัทแต่ละเว็บไซต์โดยเคร่งครัด
               </li>
               <li>
                  ข้อมูลทางสถิติสมาชิก (Demographic) เฉพาะ เพศ, อายุ, ระดับการศึกษา,อาชีพ,
                  จังหวัดและประเทศที่อยู่อาศัยจะถูกเก็บข้อมูลทุกครั้งที่มีการดาวน์โหลดตัวอย่าง หนังสืออิเล็กทรอนิกส์
                  (E-book) และการสั่งซื้อหนังสืออิเล็กทรอนิกส์ (E-book)
                  ซึ่งข้อมูลดังกล่าวจะถูกแจ้งให้กับสำนักพิมพ์ที่เป็นเจ้าของลิขสิทธ์หนังสืออิเล็กทรอนิกส์ (E-book)
                  เพื่อใช้ในการวิเคารห์ทางสถิติโดยที่ hytexts.com จะไม่มีการเปิดเผยชื่อ-นามสกุล ,email address,
                  ชื่อโปรไฟล์ หรือข้อมูลอื่นที่ไม่ได้แจ้งไว้ดังข้างต้นเป็นอันขาด
               </li>
               <li>
                  ข้อมูลเพื่อการติดต่อ ได้แก่ ที่อยู่ทางไปรษณีย์ ข้อมูลการจัดส่ง ที่อยู่สำหรับส่งเอกสารใบแจ้งหนี้
                  หมายเลขโทรศัพท์ ที่อยู่อีเมล์ ไลน์ไอดี (LINE ID) บัญชีผู้ใช้ Facebook ไอดี Facebook (Facebook ID) ไอดี
                  Google (Google ID) และบัญชีผู้ใช้ในเว็บไซต์โซเชียลมีเดียอื่นๆ ข้อมูลผู้ติดต่อ (เช่น หมายเลขโทรศัพท์
                  ข้อมูลการติดต่อบนช่องทางอื่นๆ (เช่น การติดต่อสื่อสารเป็นลายลักษณ์อักษรกับท่าน))
                  และข้อมูลเพื่อการติดต่ออื่นๆที่ท่านได้มอบให้แก่เรา
               </li>
               <li>
                  ข้อมูลการทำธุรกรรม เช่น ข้อมูลเกี่ยวกับการชำระเงินไปยังและจากท่าน วันที่และ/หรือเวลาที่ชำระเงิน
                  ยอดชำระเงิน ข้อมูลเกี่ยวกับการขอเงินคืน ยอดเงินคืน วันที่และสถานที่ที่ซื้อ
                  หมายเลขการซื้อหรือคำสั่งซื้อ วันนัดหมายเข้ารับบริการ ที่อยู่/วันที่และเวลาในการรับหรือจัดส่ง
                  ข้อความตอบรับของผู้รับ ข้อความลงท้ายในอีเมล์ของผู้รับ ข้อมูลการรับประกันสินค้า
                  คำร้องเรียนและข้อเรียกร้อง ข้อมูลการจอง ข้อมูลการเช่า ธุรกรรม ประวัติการทำธุรกรรม สถานที่
                  สถานะของธุรกรรม ธุรกรรมทางการขายในอดีต สถานะ สถานะการทำธุรกรรม พฤติกรรมการซื้อ และข้อมูลอื่นๆ
                  ของผลิตภัณฑ์และบริการที่ท่านซื้อ
               </li>
               <li>
                  ข้อมูลทางเทคนิค เช่น เลขที่อยู่ไอพีหรืออินเทอร์เน็ตโพรโทคอล (IP address) คุกกี้ ที่อยู่ media access
                  control (MAC) เว็บบีคอน (web beacon) ล็อก (Log) รหัสอุปกรณ์ (Device ID) รุ่นอุปกรณ์และประเภทของอุปกรณ์
                  เครือข่าย ข้อมูลการเชื่อมต่อ ข้อมูลการเข้าถึง ข้อมูลการเข้าใช้งานแบบ single sign-on (SSO)
                  การเข้าสู่ระบบ (Login log) ระยะเวลาและสถานที่ที่เข้าถึง ระยะเวลาที่ใช้บนหน้าเพจ ข้อมูลการเข้าสู่ระบบ
                  ประวัติการค้นหา ข้อมูลการเรียกดู ประเภทและเวอร์ชั่นของเบราว์เซอร์ การตั้งค่าเขตเวลา (Time zone
                  setting) และสถานที่ตั้ง ประเภทและเวอร์ชั่นของปลั๊กอินเบราว์เซอร์ ระบบปฏิบัติการและแพลตฟอร์ม
                  และเทคโนโลยีอื่นๆ บนอุปกรณ์ที่ท่านใช้ในการเข้าถึงแพลตฟอร์ม และข้อมูลทางเทคนิคอื่นๆ
                  จากการใช้บนแพลตฟอร์มและระบบปฏิบัติการ
               </li>
               <li>
                  ข้อมูลเกี่ยวกับพฤติกรรม เช่น ข้อมูลเกี่ยวกับพฤติกรรมการซื้อของท่าน
                  และข้อมูลที่ได้รับจากการใช้ผลิตภัณฑ์และบริการของเรา
               </li>
               <li>
                  รายละเอียดข้อมูลส่วนตัว เช่น ชื่อผู้ใช้และรหัสผ่านของท่าน รายละเอียดและรูปภาพข้อมูลส่วนตัว การซื้อ
                  ประวัติคำสั่งซื้อ คำสั่งซื้อในอดีต ประวัติการซื้อ สินค้าที่ซื้อ จำนวนสินค้า
                  คำสั่งซื้อหรือคำสั่งเรียกคืนสินค้าโดยท่าน คำสั่งซื้อผ่านทางเว็บไซต์ รายละเอียดการเก็บเงินปลายทาง (Cash
                  on Delivery) ไอดีคำสั่งซื้อ (order ID) รหัสส่วนลดและโปรโมชันที่ท่านใช้ รายละเอียดคำสั่งซื้อของลูกค้า
                  การบริการลูกค้า การเข้าร่วมนิทรรศการการค้าและกิจกรรม นิทรรศการการค้า การทดสอบและทดลองใช้งาน
                  และรายละเอียดข้อมูลส่วนตัวอื่นๆ
               </li>
               <li>
                  ข้อมูลการใช้งาน เช่น ข้อมูลเกี่ยวกับการค้นหาหรือใช้งานของท่านบนเว็บไซต์ แพลตฟอร์ม แอปพลิเคชัน
                  การใช้ผลิตภัณฑ์และบริการของเรา สินค้าในรถเข็น รายการสินค้าที่สนใจ การติดตามร้านค้า (Follow-shop
                  record) การถูกใจ และข้อมูลการใช้งานอื่นๆ
               </li>
               <li>
                  ข้อมูลทางการตลาดและการติดต่อสื่อสาร เช่น ความต้องการของท่านในการรับข้อมูลทางการตลาดจากเรา
                  บริษัทในเครือ บริษัทย่อย พันธมิตรทางธุรกิจ หรือบริษัทอื่นๆ และรูปแบบการติดต่อสื่อสารที่ต้องการ
                  และข้อมูลทางการตลาดและการติดต่อสื่อสารอื่นๆ
               </li>
            </ol>
            <p>
               หากท่านได้ให้ข้อมูลส่วนบุคคลของบุคคลที่สามแก่เรา (เช่น ผู้รับผลประโยชน์ ผู้ติดต่อฉุกเฉิน บคคลที่อ้างอิง
               และผู้อ้างอิง) เช่น ชื่อ นามสกุล ที่อยู่ หมายเลขโทรศัพท์ รายได้ของบุคคลในครอบครัว
               และข้อมูลส่วนตัวและข้อมูลเพื่อการติดต่ออื่นเพื่อติดต่อในกรณีฉุกเฉิน กรอกใบสมัครหรือทำธุรกรรมของคุณกับเรา
               กรุณาแจ้งบุคคลเหล่านั้นให้ทราบถึงนโยบายความเป็นส่วนตัวฉบับนี้ และ/หรือขอความยินยอมจากบุคคลเหล่านั้น
               หากจำเป็นเพื่อเรา เราจะเก็บรวบรวม ใช้
               หรือเปิดเผยข้อมูลที่ละเอียดอ่อนก็ต่อเมื่อได้รับความยินยอมโดยชัดแจ้งจากท่าน
               หรือในกรณีที่กฎหมายอนุญาตให้ดำเนินการได้ เราจะเก็บรวบรวมข้อมูลของผู้เยาว์ คนเสมือนไร้ความสามารถ
               คนไร้ความสามารถต่อเมื่อได้รับความยินยอมจากผู้ใช้อำนาจปกครองที่มีอำนาจกระทำการแทนผู้เยาว์ ผู้พิทักษ์
               หรือผู้อนุบาล เท่านั้น เราจะไม่เก็บรวบรวมข้อมูลจากลูกค้าที่เรารู้โดยแจ้งชัดว่าอายุต่ำกว่ายี่สิบปี
               หรือจากคนเสมือนไร้ความสามารถและคนไร้ความสามารถหากไม่ได้รับความยินยอมจากผู้ใช้อำนาจปกครองที่มีอำนาจกระทำการแทนผู้เยาว์
               ผู้พิทักษ์ หรือผู้อนุบาล ในกรณีที่จำเป็นต้องได้รับความยินยอม ในกรณีที่เราทราบว่า
               เราได้เก็บรวบรวมข้อมูลส่วนบุคคลโดยไม่มีเจตนาจากบุคคลใดๆ ที่อายุต่ำกว่ายี่สิบปี คนเสมือนไร้ความสามารถ
               หรือคนไร้ความสามารถโดยไม่ได้รับความยินยอมจากผู้ใช้อำนาจปกครองที่มีอำนาจกระทำการแทนผู้เยาว์ ผู้พิทักษ์
               หรือผู้อนุบาล เราจะดำเนินการลบข้อมูลดังกล่าวทันที
               หรือประมวลผลเฉพาะในส่วนของข้อมูลที่เราสามารถกระทำได้บนฐานทางกฎหมายอื่นๆ นอกเหนือจากการขอความยินยอม
            </p>
         </div>

         <div>
            <h2>เหตุใดเราจึงเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน</h2>
            <p>
               วัตถุประสงค์ที่ต้องได้รับความยินยอมจากท่าน <br />
               การตลาดและการติดต่อสื่อสาร: เราเก็บรวบรวม ใช้
               และเปิดเผยข้อมูลส่วนบุคคลของท่านเพื่อมอบสิทธิพิเศษและโปรโมชั่น ข่าวสาร การลดราคา ข้อเสนอพิเศษ การโฆษณา
               การแจ้งเตือน ข่าวสาร ข้อมูล การตลาดและการติดต่อสื่อสารต่างๆ เกี่ยวกับผลิตภัณฑ์และบริการจากเรา
               บริษัทในเครือ บริษัทย่อย ซึ่งเราไม่สามารถอาศัยฐานทางกฎหมายอื่น <br />
               กรุณาติดต่อ บริษัท ไฮเท็คซ์ อินเตอร์แอคทีฟ จำกัด
               เพื่อจัดการความยินยอมของท่านสำหรับการตลาดและการติดต่อสื่อสาร
            </p>
            <p>
               วัตถุประสงค์และฐานทางกฎหมายอื่นๆที่เราใช้เพื่อการประมวลผลข้อมูลส่วนบุคคลของท่าน เราอาจอาศัย (1)
               ฐานทางสัญญาในการเข้าทำสัญญาหรือการปฏิบัติตามสัญญากับท่าน (2) หน้าที่ตามกฎหมาย
               เพื่อการปฏิบัติหน้าที่ตามกฎหมาย (3) ประโยชน์โดยชอบด้วยกฎหมายของเราและของบุคคลภายนอก (4)
               ประโยชน์ซึ่งจำเป็นเพื่อการป้องกันหรือระงับอันตรายต่อชีวิต ร่างกาย หรือสุขภาพของบุคคล และ/หรือ (5)
               ประโยชน์สาธารณะ สำหรับการดำเนินภารกิจเพื่อประโยชน์สาธารณะ หรือการใช้สิทธิของเจ้าหน้าที่ของรัฐ
            </p>
            <p>เราอาจเก็บรวบรวม ใช้และเปิดเผยข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ดังต่อไปนี้</p>
            <ol>
               <li>
                  เพื่อจัดหาผลิตภัณฑ์และบริการให้แก่ท่าน เพื่อเข้าทำสัญญาและจัดการความสัมพันธ์ตามสัญญาระหว่างเรากับท่าน
                  เพื่อสนับสนุนและดำเนินกิจกรรมอื่นๆ ที่เกี่ยวข้องกับบริการ หรือผลิตภัณฑ์ต่างๆ ดังกล่าว
                  เพื่อจัดการการจองให้สำเร็จ และเพื่อดำเนินธุรกรรมทางการเงินและบริการที่เกี่ยวข้องกับการชำระเงิน
                  รวมถึงการตรวจสอบและการยืนยันและยกเลิกธุรกรรม เพื่อประมวลผลคำสั่งซื้อของท่าน การจัดส่ง การรับสินค้า
                  และการส่งคืนสินค้า การคืนเงินและการเปลี่ยนสินค้าหรือบริการ
                  เพื่อรายงานสถานะการจัดส่งสินค้าและเพื่อดำเนินกิจกรรมภายในคลังสินค้า รวมถึง การรับ การจัด
                  และการติดฉลากผลิตภัณฑ์ เพื่อตรวจสอบการรับประกัน เพื่อให้บริการหลังการขาย รวมถึง
                  การนัดหมายบริการการบำรุงรักษาและการอำนวยความสะดวก
               </li>
               <li>
                  การตลาดและการติดต่อสื่อสาร เพื่อมอบสิทธิพิเศษและโปรโมชั่น ข่าวสาร การลดราคา ข้อเสนอพิเศษ การโฆษณา
                  การแจ้งเตือน ข่าวสาร ข้อมูล การตลาดและการติดต่อสื่อสารต่างๆ เกี่ยวกับผลิตภัณฑ์และบริการจากเรา
                  บริษัทในเครือ บริษัทย่อย
               </li>
               <li>
                  โปรแกรมการเป็นลูกค้าอย่างต่อเนื่อง (Loyalty programs) โปรแกรมการสะสมคะแนน (Reward programs)
                  การจับรางวัล การแข่งขัน กิจกรรม เพื่อให้ท่านได้เข้าร่วมโปรแกรมการเป็นลูกค้าอย่างต่อเนื่อง (Loyalty
                  programs) โปรแกรมการสะสมคะแนน การชิงโชค การจับรางวัล การแข่งขัน เพื่อการเข้าร่วมกิจกรรม
                  การจัดอบรมสัมมนา และช่องทางการสื่อสารที่เกี่ยวข้องต่างๆ (เช่น การส่งอีเมล์แจ้งเตือน)โดยรวมถึง
                  การประมวลผลและจัดการการลงทะเบียนบัญชีผู้ใช้งานของท่าน การลงทะเบียนรับของขวัญ
                  การลงทะเบียนเข้าร่วมกิจกรรม เพื่อการประมวลคะแนน การสะสม เพิ่ม แลกเปลี่ยน หรือได้รับคะแนน
                  การแลกหรือจ่ายด้วยคะแนน และการโอนคะแนน เพื่อการตรวจสอบประวัติการใช้งานทั้งทางออนไลน์และออฟไลน์
                  เพื่อการมอบบัตรกำนัล บัตรของขวัญ และออกใบแจ้งหนี้
               </li>
               <li>
                  การลงทะเบียนและการยืนยันตัวตน เพื่อลงทะเบียน ตรวจสอบ ยืนยัน ระบุและ/หรือ รับรองท่านหรือตัวตนของท่าน
               </li>
               <li>
                  เพื่อดูแลความสัมพันธ์ระหว่างเรากับท่าน
                  เพื่อติดต่อและสื่อสารกับท่านตามที่ท่านขอหรือที่เกี่ยวข้องกับผลิตภัณฑ์และการบริการที่ท่านได้รับจากเรา
                  บริษัทในเครือ บริษัทย่อย เพื่อจัดการในด้านต่างๆ ที่เกี่ยวข้องกับการบริการลูกค้า ไม่ว่าจะเป็น คำถาม
                  คำขอ ผลตอบรับ คำร้องเรียน ข้อเรียกร้อง ข้อพิพาท หรือการเยียวยาชดใช้ค่าเสียหาย
                  เพื่อให้ความช่วยเหลือทางเทคนิคและแก้ไขปัญหาทางเทคนิค เพื่อประมวลผลและปรับปรุงข้อมูลของท่าน
                  เพื่ออำนวยความสะดวกแก่ท่านในการใช้ผลิตภัณฑ์และรับบริการ
               </li>
               <li>
                  การมอบประสบการณ์เฉพาะบุคคล (Personalization) การวิเคราะห์ข้อมูลตามความสนใจหรือพฤติกรรมของลูกค้า
                  (Profiling) และการวิเคราะข้อมูล (Data Analytics) เพื่อแนะนำผลิตภัณฑ์และบริการที่ท่านอาจสนใจ
                  ระบุความชอบของท่าน และมอบประสบการณ์ที่เหมาะสมกับท่าน เพื่อเรียนรู้เพิ่มเติมเกี่ยวกับท่าน
                  ผลิตภัณฑ์และบริการที่ท่านได้รับ และผลิตภัณฑ์และการบริการอื่นๆ ที่ท่านอาจสนใจ
                  เพื่อประเมินความความสนใจหรือพฤติกรรมของท่านที่มีต่อผลิตภัณฑ์และการบริการ เพื่อดำเนินการวิเคราะห์ข้อมูล
                  (Data analytics) การทำความสะอาดข้อมูล (Data cleansing)
                  และการวิเคราะห์ข้อมูลตามความสนใจหรือพฤติกรรมของลูกค้า (Data profiling)
                  เพื่อทำการค้นคว้าวิจัยทางการตลาด ทำแบบสำรวจ ประเมินผล พฤติกรรม สถิติและการแบ่งประเภท
                  รูปแบบและกระแสความนิยมด้านการบริโภค การวิเคราะห์ข้อมูลตามความสนใจหรือพฤติกรรม (Profiling)
                  จากการประมวลผลข้อมูลส่วนบุคคลของท่าน เช่น
                  การประมวลผลจากชนิดของผลิตภัณฑ์และประเภทของการบริการที่ท่านใช้หรือได้รับ
                  ช่องทางที่ท่านต้องการได้รับการติดต่อ เพื่อรู้จักท่านมากขึ้น
                  และเพื่อยกระดับการดำเนินธุรกิจให้ดียิ่งขึ้น ตลอดจนเพื่อปรับเปลี่ยนเนื้อหาให้ตรงกับความพึงพอใจ
                  เพื่อพิจารณาความมีประสิทธิภาพของแคมเปญส่งเสริมการขาย
                  เพื่อระบุและแก้ไขปัญหาที่เกิดขึ้นกับผลิตภัณฑ์และการบริการที่มีอยู่ เพื่อการพัฒนาคุณภาพของข้อมูล
                  เพื่อจุดประสงค์ดังกล่าว
                  เราจะเก็บรวบรวมและเปิดเผยข้อมูลส่วนบุคคลของท่านเพื่อความสนใจและผลประโยชน์ของท่าน
                  และเพื่อประโยชน์โดยชอบด้วยกฎหมายและการดำเนินธุรกิจของบริษัท บริษัทในเครือ บริษัทย่อย
                  ซึ่งไม่เกินกว่าสิทธิขั้นพื้นฐานในข้อมูลส่วนบุคคลของเจ้าของข้อมูลส่วนบุคคล ทั้งนี้
                  เราจะขอความยินยอมจากท่านเป็นคราว ๆ ไป หากจำเป็น
               </li>
               <li>
                  เพื่อยกระดับการดำเนินธุรกิจ ผลิตภัณฑ์และการบริการให้ดียิ่งขึ้น เพื่อประเมิน พัฒนา จัดการและยกระดับ
                  ค้นคว้าวิจัยและพัฒนาการให้บริการ ผลิตภัณฑ์ ระบบและการดำเนินธุรกิจให้แก่ท่านและลูกค้าของเราทั้งหมด
                  บริษัทในเครือ บริษัทย่อย เพื่อระบุและแก้ไขปัญหาที่เกิดขึ้น
                  เพื่อจัดทำรายงานภาพรวมของข้อมูลแบบไม่ระบุตัวตน และประเมินประสิทธิภาพในเรื่องผลิตภัณฑ์ สื่อดิจิทัล
                  และแคมเปญทางการตลาด
               </li>
               <li>
                  การทำงานของเว็บไซต์ แอปพลิเคชันมือถือ และแพลตฟอร์ม เพื่อดูแล ดำเนินงาน ติดตาม สังเกตการณ์
                  และจัดการเว็บไซต์และแพลตฟอร์มเพื่ออำนวยความสะดวกและรับรองให้ท่านมั่นใจว่าเว็บไซต์และแพลตฟอร์มทำงานอย่างราบรื่น
                  มีประสิทธิภาพและปลอดภัย เพื่ออำนวยความสะดวกท่านในการใช้งานเว็บไซต์และแพลตฟอร์ม
                  เพื่อปรับปรุงแผนงานและเนื้อหาของเว็บไซต์และแพลตฟอร์มให้ดียิ่งขึ้น
               </li>
               <li>
                  การบริหารจัดการทางด้านเทคโนโลยีสารสนเทศ เพื่อวัตถุประสงค์ในการบริหารจัดการธุรกิจ
                  รวมถึงการจัดการระบบปฎิบัติการด้านเทคโนโลยีสารสนเทศ การจัดการระบบติดต่อสื่อสาร
                  ระบบความปลอดภัยทางด้านเทคโนโลยีสารสนเทศ และการตรวจสอบความปลอดภัยทางด้านเทคโนโลยีสารสนเทศ
                  การจัดการภายในด้านธุรกิจตามข้อปฏิบัติภายใน นโยบายและกระบวนการต่างๆ
               </li>
               <li>
                  การปฎิบัติตามหน้าที่ตามกฎข้อบังคับและข้อผูกพัน เพื่อดำเนินการให้เป็นไปตามบทบัญญัติติแห่งกฎหมาย
                  กระบวนการทางกฎหมาย หรือคำสั่งของหน่วยงานรัฐซึ่งรวมถึงหน่วยงานรัฐภายนอกประเทศไทย
                  และ/หรือให้ความร่วมมือกับศาล ผู้กำกับดูแล หน่วยงานรัฐ และหน่วยงานที่บังคับใช้กฎหมาย
                  ในกรณีที่มีเหตุผลอันควรเชื่อได้ว่าเราต้องดำเนินการดังกล่าวเพื่อปฎิบัติตามกฎหมายและในกรณีที่เราจำเป็นต้องเปิดเผยข้อมูลส่วนบุคคลของท่านอย่างเคร่งครัดเพื่อปฏิบัติตามบทบัญญัติแห่งกฎหมาย
                  กระบวนการทางกฎหมาย หรือคำสั่งของรัฐดังกล่าว โดยรวมถึง
                  การให้บริการและการจัดการเรื่องบริการการขอคืนภาษีมูลค่าเพิ่ม (VAT refund) การออกใบกำกับภาษี
                  หรือออกแบบฟอร์มภาษีแบบเต็ม การบันทึกและติดตามการติดต่อสื่อสาร
                  การเปิดเผยข้อมูลให้แก่หน่วยงานที่มีอำนาจจัดเก็บภาษี ผู้กำกับดูแลด้านบริการทางการเงิน
                  และองค์กรและหน่วยงานรัฐอื่นๆ ที่กำกับดูแล และเพื่อการสืบสวนสอบสวนหรือป้องกันอาชญากรรม
               </li>
               <li>
                  การปกป้องผลประโยชน์ของเรา เพื่อปกป้องความมั่นคงและความเชื่อมั่นทางธุรกิจของบริษัท
                  เพื่อใช้สิทธิหรือปกป้องผลประโยชน์ของเราที่จำเป็นและสามารถทำได้ตามกฎหมาย เช่น การตรวจจับ ป้องกัน
                  และตอบโต้ข้อเรียกร้องการทุจริต การละเมิดทรัพย์สินทางปัญญา หรือการไม่ปฏิบัติตามกฎหมาย
                  เพื่อจัดการและป้องกันความเสียหายแก่ทรัพย์สินและสมบัติของเรา
                  เพื่อการปฏิบัติตามข้อกำหนดและเงื่อนไขของเรา
                  เพื่อตรวจจับและป้องกันการประพฤติที่มิชอบภายในองค์กรซึ่งรวมไปถึงการใช้กล้องวงจรปิด
                  เพื่อติดตามเฝ้าระวังเหตุการณ์ เพื่อป้องกันและรายงานความผิดทางอาญา
                  และเพื่อปกป้องความมั่นคงและและความเชื่อมั่นทางธุรกิจของบริษัท
               </li>
               <li>
                  การตรวจจับการทุจริต เพื่อตรวจสอบตัวตนของท่าน และเพื่อดำเนินการตรวจสอบทางกฎหมายหรือกฎข้อบังคับอื่นๆ
                  ที่บังคับใช้ (เช่น เพื่อดำเนินการตามกฎหมายป้องกันและปราบปรามการฟอกเงิน และป้องกันการทุจริต) ทั้งนี้
                  รวมไปถึงการจัดทำรายชื่อผู้มีความเสี่ยง (Sanction list checking) การตรวจสอบและทำบันทึกภายใน
                  การจัดการทรัพย์สิน ระบบ และการควบคุมทางธุรกิจอื่นๆ
               </li>
               <li>
                  การทำธุรกรรมขององค์กร ในกรณีที่มีการขาย การโอน การควบรวม การปรับโครงสร้างองค์กร หรือเหตุการณ์อื่นๆ
                  ที่ใกล้เคียงกัน เราอาจโอนข้อมูลส่วนบุคคลของท่านไปยังบุคคลภายนอกอื่นๆ ไม่ว่าจะรายเดียวหรือหลายราย
                  อันเป็นส่วนหนึ่งของการทำธุรกรรมนั้นๆ
               </li>
               <li>
                  ความเสี่ยง เพื่อดำเนินการบริหารความเสี่ยง การตรวจสอบการดําเนินงาน และการประเมินความเสี่ยง และ/หรือ
               </li>
               <li>ชีวิต เพื่อป้องกันหรือยับยั้งอันตรายที่เกิดขึ้นต่อชีวิต ร่างกาย หรือสุขภาพของบุคคล</li>
            </ol>
            <p>
               หากท่านไม่สามารถให้ข้อมูลส่วนบุคคลแก่เราเมื่อมีการร้องขอ
               เราอาจไม่สามารถนำเสนอหรือจัดหาผลิตภัณฑ์หรือบริการของเราแก่ท่านได้
            </p>
         </div>

         <div>
            <h2>การเปิดเผยข้อมูลแก่บุคคลที่สาม</h2>
            <p>
               hytexts.com
               อาจใช้ข้อมูลที่ได้รับจากสมาชิกเพื่อใช้ในการการส่งเสริมการตลาดหรือให้ข้อมูลแก่หน่วยงานที่ทำหน้าที่ด้านการตลาดโดย
               hytexts.com เป็นผู้ว่าจ้างพันธมิตรทางธุรกิจหรือผู้ให้การสนับสนุนทางธุรกิจ ตามที่ hytexts.com เห็นสมควร
            </p>
            <p>การเปิดเผยข้อมูลนั้น ๆ เป็นไปโดยถูกต้องตามกฎหมายหรือตามคำสั่งของหน่วยงานของรัฐที่เกี่ยวข้อง</p>
            <p>
               <b>การโอนข้อมูลส่วนบุคคลของท่านไปยังต่างประเทศ</b>
               <br />
               เราอาจเปิดเผยหรือโอนข้อมูลส่วนบุคคลของท่านไปยังบุคคลภายนอกหรือเซิร์ฟเว่อร์ที่อยู่ในต่างประเทศซึ่งประเทศปลายทางอาจมี
               หรืออาจไม่มีระดับการคุ้มครองข้อมูลส่วนบุคคลที่เท่าเทียมกัน ทั้งนี้
               เราจะดำเนินการตามขั้นตอนและมาตรการต่างๆ
               เพื่อทำให้ท่านมั่นใจได้ว่าการโอนข้อมูลส่วนบุคคลของท่านจะโอนอย่างปลอดภัยและบุคคลที่รับโอนข้อมูลนั้นมีระดับการคุ้มครองข้อมูลส่วนบุคคลที่เหมาะสมหรือกรณีอื่นๆ
               ตามที่กฎหมายกำหนด
               และเราจะขอความยินยอมจากท่านเพื่อการโอนข้อมูลส่วนบุคคลของท่านไปยังต่างประเทศหากจำเป็นต้องปฏิบัติตามที่กฎหมายกำหนด
            </p>
            <p>
               <b>ความปลอดภัยของข้อมูล</b>
               <br />
               บริษัทตระหนักถึงความสำคัญของการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลของท่าน
               บริษัทจึงพยายามอย่างยิ่งที่จะปกป้องข้อมูลของท่านด้วยการกำหนดให้มีมาตรการในการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลของท่านอย่างเหมาะสมและสอดคล้องกับการรักษาความลับของข้อมูลส่วนบุคคลเพื่อป้องกันการสูญหาย
               เข้าถึง ทำลาย ใช้ แปลง แก้ไขเปิดเผย หรือทำลายโดยไม่มีสิทธิหรือโดยไม่ชอบด้วยกฎหมาย
               โดยบริษัทจะตรวจสอบวิธีการเก็บรวบรวมข้อมูลส่วนบุคคล
               พื้นที่ในการจัดเก็บข้อมูลและดำเนินการตามหลักปฏิบัติในการประมวลผล รวมถึงมาตรการความปลอดภัยทางกายภาพ
               ให้เป็นไปตามที่กำหนดในนโยบายและแนวปฏิบัติในการรักษาความมั่นคงปลอดภัยด้านเทคโนโลยีสารสนเทศของบริษัท
            </p>
         </div>

         <div>
            <h2>สิทธิ์ของเจ้าของข้อมูลส่วนบุคคล</h2>
            <p style={{ marginBottom: 0 }}>
               ภายใต้บทบัญญัติแห่งกฎหมายและข้อยกเว้นตามกฎหมายที่เกี่ยวข้อง ผู้ใช้งานอาจมีสิทธิ์ตามที่ระบุไว้
            </p>
            <ol>
               <li>
                  การเข้าถึง: ผู้ใช้งานอาจมีสิทธิ์ในการขอเข้าถึงหรือขอรับสำเนาข้อมูลส่วนบุคคลที่เราเก็บรวบรวม
                  ใช้หรือเปิดเผยเกี่ยวกับผู้ใช้งาน ทั้งนี้ เพื่อความเป็นส่วนตัวและความปลอดภัยของผู้ใช้งาน
                  เราอาจขอให้ผู้ใช้งานพิสูจน์ตัวตนของผู้ใช้งานก่อนจะให้ข้อมูลตามที่ผู้ใช้งานขอ
               </li>
               <li>
                  การแก้ไขให้ถูกต้อง: ผู้ใช้งานอาจมีสิทธิ์ขอให้มีการดำเนินการแก้ไขข้อมูลส่วนบุคคลที่เราได้เก็บรวบรวม
                  ใช้หรือเปิดเผยเกี่ยวกับผู้ใช้งาน ให้ ถูกต้อง เป็นปัจจุบัน สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด
               </li>
               <li>
                  การคัดค้าน: ผู้ใช้งานอาจมีสิทธิ์คัดค้านการเก็บรวบรวม ใช้หรือเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้งาน เช่น
                  การคัดค้านการตลาดแบบตรง
               </li>
               <li>การขอให้ระงับการใช้: ผู้ใช้งานอาจมีสิทธิ์ขอให้ระงับการใช้ข้อมูลส่วนบุคคลของผู้ใช้งานในบางกรณี</li>
               <li>
                  การถอนความยินยอม: สำหรับวัตถุประสงค์ที่ผู้ใช้งานได้ให้ความยินยอมให้เราเก็บรวบรวม
                  ใช้หรือเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้งาน ผู้ใช้งานมีสิทธิ์ที่จะถอนความยินยอมของผู้ใช้งาน ณ เวลาใด
                  ก็ได้
               </li>
               <li>
                  การลบหรือทำลายข้อมูล: ผู้ใช้งานอาจมีสิทธิ์ขอให้เราดำเนินการลบหรือทำลาย
                  หรือทำให้ข้อมูลส่วนบุคคลของผู้ใช้งานที่เราเก็บรวบรวม ใช้หรือเปิดเผย
                  เป็นข้อมูลที่ไม่สามารถระบุตัวบุคคลที่เป็นเจ้าของข้อมูล เว้นเสียแต่ว่า
                  การเก็บรักษาข้อมูลดังกล่าวของเรานั้นเป็นไปเพื่อการปฏิบัติตามกฎหมาย
                  หรือเพื่อก่อตั้งสิทธิ์เรียกร้องตามกฎหมาย เพื่อการใช้ หรือการปกป้องสิทธิ์เรียกร้องตามกฎหมาย
               </li>
               <li>
                  การยื่นเรื่องร้องเรียน:
                  ผู้ใช้งานอาจมีสิทธิ์ยื่นเรื่องร้องเรียนไปยังหน่วยงานที่มีอำนาจในกรณีที่ผู้ใช้งานเชื่อว่าการเก็บรวบรวม
                  ใช้หรือเปิดเผยข้อมูลส่วนบุคคลของเรานั้นไม่ชอบด้วยกฎหมายหรือไม่สอดคล้องกับกฎหมายคุ้มครองข้อมูลที่บังคับใช้
               </li>
            </ol>
         </div>

         <div>
            <h2>รายละเอียดการติดต่อเรา</h2>
            <p style={{ marginBottom: 0 }}>
               หากท่านมีความประสงค์ที่จะใช้สิทธิของท่านที่เกี่ยวข้องกับข้อมูลส่วนบุคคลของท่าน <br />
               หรือหากท่านมีข้อสงสัยเกี่ยวกับข้อมูลส่วนบุคคลของท่านภายใต้นโยบายความเป็นส่วนตัวฉบับนี้ <br />
               โปรดติดต่อเราหรือเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลของเรา ที่
            </p>
            <ol>
               <li>
                  บริษัท ไฮเท็คซ์ อินเตอร์แอคทีฟ จำกัด (Hytexts) <br />3 อาคารพร้อมพันธุ์ 3 ชั้น 7 ห้อง 701-702 ซอย
                  ลาดพร้าว 3 แขวงจอมพล เขตจตุจักร กรุงเทพมหานคร 10900 <br />
                  โทร: 089-134-7470 (ทุกวัน 9.00-17.30 น.) <br />
                  อีเมล: contact@hytexts.com
               </li>
               <li>
                  เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล ฝ่ายคุ้มครองข้อมูลส่วนบุคคล เซ็นทรัล กรุ๊ป เลขที่ 22 ซอยสมคิด
                  ถนนเพลินจิต แขวงลุมพินี เขตปทุมวัน กรุงเทพมหานคร 10330 <br /> อีเมล:{' '}
                  <a href='dpo@central.co.th'>dpo@central.co.th</a>
               </li>
            </ol>
         </div>
      </div>
   );
};

export default Privacy;
